
export function generatePager(json, pagePerView, pagerContainer){
  let activePage = json.Offset < 1 ? 1: ((json.Offset) / 12) + 1;
  let totalEvents = json.TotalResults;

  if (totalEvents > pagePerView){
    let totalPages = Math.ceil(totalEvents/pagePerView);
    pagerContainer.innerHTML = `<p>pager: ${totalPages}</p>`
    let pager = `
    <ul class="flex align-middle justify-center gap-4">
    <li><button data-type="page" data-active="${activePage}" data-page="${activePage - 1}" style="${activePage === 1?`visibility:hidden`:``}"><svg class="rotate-90 fill-blue w-5 h-5"><use xlink:href="/spritemap.svg#sprite-dropdown"></use></svg><span class="visually-hidden">Forrige side</span></button></li>
    ${
        generatePage(totalPages, activePage)
      }      
      <li><button data-type="page" data-active="${activePage}" data-page="${activePage + 1}" style="${activePage === totalPages?`visibility:hidden`:``}"><svg class="-rotate-90 fill-blue w-5 h-5"><use xlink:href="/spritemap.svg#sprite-dropdown"></use></svg><span class="visually-hidden">Næste side</span></button></li>
      </ul>
      `
      pagerContainer.innerHTML = pager;
      
  }else{
    pagerContainer.innerHTML = "";
  }
}

export function generatePage(loop, activePage){  
  let pages = "";
  let currentPage;
  let ariaCurrent;

  for (let i = 0; i < loop; i++){
  if (activePage != i + 1) {
    currentPage = false;
    ariaCurrent = ""
  }
  else {
    currentPage = true;
    ariaCurrent = `aria-current="${currentPage}"`
  }

    pages = pages + `<li><button class="${activePage == i + 1? `active-pager`:`pager`}" ${ariaCurrent} data-type="page" data-page="${i + 1}" aria-label="side ${i + 1}">${i + 1}</button></li>`
  }
  return pages;
}